<template>
<!--  <q-item>{{match.noteHelper.name}}</q-item>-->
  <q-item dense clickable @click.native="onClick" :active="active" active-class="bg-teal-1 text-black">
    <q-item-section v-if="matchText">
      <h5 style="margin: 0;">{{match.noteHelper.name}}</h5>
      <ace-editor ref="ace" sync
                  :content="matchText"
                  :options="aceOptions"
                  class="AceSearch">
      </ace-editor>
    </q-item-section>
    <q-item-section side right>
      {{match.noteHelper.note.updatedAt}}<br/>
      <small v-html="pathText"></small>
    </q-item-section>
  </q-item>
</template>

<script>
// var Range = require('ace/range').Range;
import * as ace from 'ace-builds/src-noconflict/ace'
// import Range from 'ace/range'

export default {
  name: 'SearchResult',
  props: ['match', 'searchTerm', 'active'],
  data () {
    return {
      pathText: '',
      timeout: null,
      marker: null
    }
  },
  computed: {
    matchText () {
      // new RegExp(searchTerm)
      let retVal = ''
      const content = this.match.noteHelper.note.data
      const matchLen = this.match.len
      let matchIndex = this.match.index
      if (matchIndex < 0) return 'No Match!'
      const startIndex = matchIndex - 100
      if (startIndex <= 0) {
        retVal += content.substring(0, matchIndex)
      } else {
        retVal += content.substring(startIndex, matchIndex)
      }
      const subStart = retVal.length
      retVal += content.substr(matchIndex, matchLen)
      const subEnd = retVal.length
      let endIndex = matchIndex + 100
      if (endIndex > content.length) {
        retVal += content.substring(matchIndex + matchLen)
      } else {
        retVal += content.substring(matchIndex + matchLen, endIndex)
      }
      // eslint-disable-next-line vue/no-async-in-computed-properties
      this.$nextTick(() => {
        const start = this.editor.session.getDocument().indexToPosition(subStart, 0)
        const end = this.editor.session.getDocument().indexToPosition(subEnd, 0)
        let range = new ace.Range()
        range.start = start
        range.end = end
        // console.log(range)
        if (this.marker) this.editor.session.removeMarker(this.marker)
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.marker = this.editor.session.addMarker(
          range,
          'warning',
          'text',
          false
        )
      }, 100)
      return retVal
    },
    aceOptions: function () {
      return {
        mode: 'markdown',
        fontSize: this.fontSize,
        // theme: $ch._store().state.auth.currentUser.settings.editor.theme,
        // theme: 'dracula',
        useWorker: false,
        showGutter: false,
        showLineNumbers: false,
        highlightGutterLine: false,
        // cursor: false,
        maxLines: Infinity,
        wrap: true,
        // cursorStyle: 'slim',
        readOnly: true
      }
    }
  },
  methods: {
    shortenTitle (title, maxLen = 15) {
      if (title.length >= maxLen) {
        return title.substring(0, maxLen - 3) + '...'
      }
      return title
    },
    onClick () {
      this.$store.commit('updateSelectedTreeItemId', this.match.noteHelper.noteId)
      this.$router.push('/home/' + this.match.noteHelper.noteId)
      this.$store.commit('setSearchOpen', false)
    },
    getPathText () {
      let pathText = this.shortenTitle(this.match.noteHelper.name, 30)
      let nh = this.match.noteHelper
      while (true) {
        nh = nh.parent
        if (!nh) break
        pathText = this.shortenTitle(nh.name, 30) + '   <br/>' + pathText
      }
      return pathText
    }
  },
  beforeUpdate () {
    this.pathText = this.getPathText()
  },
  mounted () {
    console.log(this.match)
    this.editor = this.$refs['ace'].editor
    this.editor.setHighlightActiveLine(false)
    // Hide cursor
    this.editor.renderer.$cursorLayer.element.style.display = 'none'
    this.pathText = this.getPathText()
    this.timeout = null
  },
  beforeDestroy () {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
</script>

<style lang="stylus">
  .AceSearch {
    margin: 5px;
    /*padding: 0px;*/
    padding-right: 10px;
    border-radius: 5px;
    background-color: transparent;
    /*width: 100% !important;*/
    /*height: 100%;*/
    .ace_scrollbar {
      display: none
    }
    .ace_content {
      cursor: pointer !important;
    }
  }
  .warning {
    background-color: yellow;
    position: absolute;
  }
</style>
